// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-btn-style[data-v-1b0e0b31] {\n  overflow: visible;\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
